import "./App.css";
import Root from "./components/Root";

const App = () => {
  return (
    <div className=" relative  font-sans">
      <Root />
    </div>
  );
};

export default App;
